import * as modules from '../features/**/store/index.js'; //eslint-disable-line

export default {
  name: 'integrations',
  namespaced: true,
  modules,
};



// WEBPACK FOOTER //
// ./node_modules/@intelipost-modules/secure-integrations/store/index.js